import React from 'react';
import PropTypes from 'prop-types';
import HelpBlock from 'react-bootstrap/lib/HelpBlock';
import classnames from 'classnames';
import { IconButton } from '../form';
import Classes from '../Classes';
import Utils from '../Utils';
import { DocumentDateFormats, DocumentTypes, PressReleaseDocumentType } from '../Constants';
import { formatDateForLocale } from '../dateHelpers';
import {trackMixpanelEvent} from "../MixpanelHelper";
import mixpanelConstants from "../mixpanelConstants";

const suffixDocumentTypeKey = (tag, documentTypeId) => `${tag}_${DocumentTypes[documentTypeId]}`;

const Document = ({
  document, onDelete, translations, tags, exhibitorId, locale, isEditable, productId, mixpanelProps
}) => {
  let documentDownloadProps = {}
  let type = mixpanelConstants.type.exhibitor;
  if(mixpanelProps){
      documentDownloadProps = JSON.parse(mixpanelProps);
      if(documentDownloadProps?.component === mixpanelConstants.component.productDetails || documentDownloadProps?.component === mixpanelConstants.component.productDirectory){
          type = mixpanelConstants.type.product;
      }
      documentDownloadProps = {...documentDownloadProps, exhibitorId: exhibitorId, productId: productId,
          documentName: Utils.removePdfFileNameExtension(document.displayName),
          downloadUrl: document.url, documentType: DocumentTypes[document.type], type: type
      }
  }
  return (
      <div
          className={classnames([
            Classes.centerFlex,
            Classes.twoColumnLayout,
            Classes.justifySpaceBetween
          ])}
      >
        <div className={classnames([Classes.inlineBlock, Classes.documentDetailContainer])}>
          <HelpBlock className={classnames([Classes.textUppercase, Classes.helpTextSmall])}>
            <div>
              {translations.documentType[DocumentTypes[document.type]]}
              <span className={Classes.fileTypeSizePadding}>-</span>
              <span>{Utils.formatBytes(document.size)}</span>
            </div>
            {document.type === PressReleaseDocumentType ?
                <div>
                  {translations.dateOfPublication}
                  {' '}
                  <span className={Classes.documentPublishDate}>
              {formatDateForLocale(document.publishDate, DocumentDateFormats(locale), locale)}
            </span>
                </div> : null}
          </HelpBlock>
          <h3 className={Classes.wrapWordBreak}>{Utils.removePdfFileNameExtension(document.displayName)}</h3>
          <div onClick={() => {
            setTimeout(() => {
              // we need to set timeout in order to fix the event triggering twice because of target="_blank"
              trackMixpanelEvent(mixpanelConstants.eventName.documentDownloaded, documentDownloadProps)
            }, 100);
            
            }}>
              <a
                  href={document.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-dtm={suffixDocumentTypeKey(tags.download, document.type)}
                  data-dtm-attributes={JSON.stringify({
                    exhibitorId,
                    documentName: Utils.removePdfFileNameExtension(document.displayName),
                    productId
                  })}
                  className={Classes.fileName}
              >
                {translations.downloadPdf}
                <i
                    className={classnames(Classes.downArrow, Classes.iconSpaceLeft, Classes.documentDownloadIcon)}
                />
              </a>
          </div>
        </div>
        {isEditable ?
            <div className={classnames(Classes.inlineBlock, Classes.deleteButtonFloat)}>
              <IconButton
                  ariaLabel={translations.deleteButtonTitle}
                  onClick={() => onDelete(document.id)}
                  tag={tags.delete}
                  iconClass={Classes.icons.delete}
                  className={Classes.secondary02Button}
              />
            </div>
            : null}
      </div>
  )
};

Document.propTypes = {
  document: PropTypes.object.isRequired,
  onDelete: PropTypes.func,
  translations: PropTypes.object.isRequired,
  tags: PropTypes.shape({
    delete: PropTypes.string,
    download: PropTypes.string.isRequired
  }).isRequired,
  exhibitorId: PropTypes.string,
  productId: PropTypes.string,
  locale: PropTypes.string.isRequired,
  isEditable: PropTypes.bool,
  mixpanelProps: PropTypes.object
};

export default Document;
